import { render } from "./FilesPage.vue?vue&type=template&id=94d25154&scoped=true"
import script from "./FilesPage.vue?vue&type=script&lang=js"
export * from "./FilesPage.vue?vue&type=script&lang=js"

import "./FilesPage.vue?vue&type=style&index=0&id=94d25154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d25154"]])

export default __exports__